import React, { FC, useState, useEffect, useMemo, ChangeEvent } from "react";
import { useDispatch, useSelector } from "react-redux";
import { subSeconds } from "date-fns";
import { RootState } from "store/ducks";
// generics
import * as S from "../../styles";
// components
import Text from "components/Text";
import QuoteItem from "../QuoteItem";
import Loading from 'components/Loading';
import ActionIcons from "./components/ActionIcons";
import IndicatorItem from "./components/IndicatorItem";
import { Visibility } from "components/Visibility";
import CheckboxInput from "../../../../Input/Checkbox";
import { Toggle } from "pages/Quotes/components/Toggle";
import { colors } from "../../../../../../styles/colors";
import { BudgetHistory } from "./components/BudgetHistory";
import { MapProductLine } from "./components/MapProductLine";
import StatusCircleOptions from "components/StatusCircleOptions";
import Tooltip from "pages/Quotes/components/generics/Tooltip/Tooltip";
import { VisibilityConditional } from "components/VisibilityConditional";
import { NewBudgetButtons } from "../QuoteItem/components/NewBudgetButtons";
import QuoteActionButton from "../../../../../QuoteActionButton/QuoteActionButton";
import IndicatorRefreshButton from "pages/Quotes/components/IndicatorRefreshButton";
import ItemValidityModal from "../../../../../../components/generics/Modal/ItemValidityModal/ItemValidityModal";
// interfaces
import { ITRow } from "./interface";
import { NewBudgetProps } from "../QuoteItem/interface";
import { IQuoteDetailItem } from "models/QuoteDetailItem";
import { HistoryProps } from "./components/BudgetHistory/interface";
import { ProductsSuggestionProps } from "pages/Quotes/MapProduct/interface";
import { HistorytSatusDescription, StatusType, SupplierStatusType } from "components/Table/interface";
// services
import QuoteService from 'services/quote.service';
// utils
import { ExistsDuplicatedItem } from "./utils";
import { toastify } from "components/Toastify/utils";
import { IsNullOrEmpty } from "utils/StringNullOrEmpty";
import { toastExclusion } from "pages/Quotes/utils/Quotes";
//context
import { useTabsContext } from "contexts/Tabs";
import { useOutPortfolioContext } from "contexts/OutPortfolio";
import { useDetailsQuoteContext } from "contexts/DetailsQuote";
import { useConversionFactorContext } from "contexts/ConversionFactor";
//assets
import { Button } from "components/Button";
import refreshRed from 'img/refresh-red.svg';
import deleteBtn from 'img/delete-icon-new.svg';
import { AnotherCd } from "../QuoteItem/components/NewBudgetButtons/styles";
//images
import priorityIcon from 'img/icon-indicator-priority-item.svg';
import removeBtn from "img/cancel-icon.svg";
import confirmBtn from "img/confirm-icon.svg";
import { UpdateApprovedMapAutomaticProps } from "models/MapProduct";

const TRow: FC<ITRow> = ({
	item,
	index,
	quoteId,
	cdFilter,
	customProps,
	customerCode,
	changeToggle,
	isNoSegmented,
	productSelected,
	orderBudgetHistory,
	setProductSelected,
	ableNegotiacionBtn,
	distributionCenters,
	notifyHistoryOpened,
	notifyTooltipToClose,
	handleChangeSelectItems,
	segmentsWithoutPriceLock,
	refreshQuoteSentHeaderTabs,
	distributionCenterSelected,
	reproveMapProduct,
	approveMapProduct,
}) => {
	const [isEditingQuoteItem, setEditingQuoteItem] = useState(true);
	const [quoteItemLoading, setQuoteItemLoading] = useState(false);
	const [selectedBudgetCd, setSelectedBudgetCd] = useState({});
	const [warningToolTip, setwarningToolTip] = useState(false);
	const [totalAmount, setTotalAmount] = useState<number>(0);
	const [selectedCDItem, setSelectedCDItem] = useState("");
	const [checked, setChecked] = useState(false);
	const [historyBudgets, setHistoryBudgets] = useState<HistoryProps[]>(item.budgetHistory ?? []);

	const sentBionexo = item?.budgets?.budgetHistory?.find((x: any) => x.sentBionexo);
	const [exclusionCondition, setExclusionCondition] = useState<boolean>(!(item.budgets.supplierProductCode === sentBionexo?.supplierProductCode));

  const bcgOnly = process.env.REACT_APP_BCG_ONLY === 'true';

	const user = useSelector((state: RootState) => state.user);
	const _quoteService = new QuoteService();
	const dispatch = useDispatch();

	const { setDisableTabs, disableTabs } = useTabsContext();
	const { disabled, handleOutPortfolio, portfolio } = useOutPortfolioContext();
	const {
		useMoney,
		quoteItem,
		quoteDetail,
		updateChecked,
		isQuoteExpired,
		setUpdateChecked,
		setRenderAgainMoney
	} = useDetailsQuoteContext();
	const { updateConversionFactorState } = useConversionFactorContext();

	const bionexoStatus = quoteDetail?.status;
	const viveoStatus = quoteDetail?.supplierStatus;
	const tabSelected = !!(distributionCenterSelected && distributionCenterSelected !== 'default');
	const isOpen = bionexoStatus === StatusType.OPEN;

	const statusQuotation = isOpen && viveoStatus === SupplierStatusType.VALIDATE_PORTAL;

	const mapSavedItem = useMemo(() => (!IsNullOrEmpty(item.budgets) ? item.budgets?.maps : null), [item.budgets, item.budgetSaved]);
	const suggestedSelected = tabSelected && !statusQuotation && item.budgets?.sequence;
	const suggested = useMemo(() => (item.productsSuggestion?.find((i: any) => suggestedSelected ? Number(i.sequentialSuggestion) === (item.budgets?.sequence + 1) : i.suggested)), [suggestedSelected, item]);
	const itemStock = useMemo(() => (suggested?.itemStock.find((stock: any) => stock.local == item.distributionCenter)), [item, suggested]);

	const integrationMessages = quoteDetail?.integrationMessages?.find((message) => message.distributionCenter === distributionCenterSelected);
	const detailsItem = quoteItem?.data?.find((i: IQuoteDetailItem) => i.productCode === item.productCode);

	const quantityRule = (totalAmount && suggested?.id) ? totalAmount : "-";
	const unblockedStockAndNotDefaultDc = !itemStock?.blocked || distributionCenterSelected === 'default';
	const sentQuoteStatus = quoteDetail?.status === StatusType.SENT || quoteDetail?.status === StatusType.UPDATED;
	const exclusionVisibility = !isQuoteExpired ? (useMoney && sentQuoteStatus && !isEditingQuoteItem && cdFilter?.distributionCenter !== 'default' || integrationMessages?.statusViveo === "Pendente Money") : !ableNegotiacionBtn && !isEditingQuoteItem;
	const enableButtons = !orderBudgetHistory && ((quoteDetail?.status !== StatusType.CLOSED && quoteDetail?.supplierStatus !== SupplierStatusType.EXPIRED) ||
		(quoteDetail?.status !== StatusType.CLOSED && quoteDetail?.supplierStatus !== SupplierStatusType.DO_NOT_PARTICIPATE)) && quoteDetail?.status !== StatusType.PROCESSING;

	const blockedPendingMoney = (integrationMessages?.statusViveo === "Pendente Money" && cdFilter?.distributionCenter !== 'default');
	const disableCheckboxInput = quoteDetail?.status === StatusType.PURCHASE_ORDER || !enableButtons || isEditingQuoteItem || !suggested || blockedPendingMoney || ableNegotiacionBtn || itemStock?.blocked;

	const isOrder = quoteDetail?.status === StatusType.PURCHASE_ORDER || !enableButtons || blockedPendingMoney;
	const editVisibility = (!isQuoteExpired && !isOrder && (!sentQuoteStatus || unblockedStockAndNotDefaultDc)) || (isQuoteExpired && isEditingQuoteItem);

	const duplicateItem = (cd: string, isOriginal: boolean) => {
		if (isOriginal)
			return <Text><strong>Item original:</strong> este item foi duplicado e também possui resposta para o CD de {cd}</Text>;
		else
			return <Text><strong>Item duplicado:</strong> o item original possui resposta para o CD de {cd}</Text>;
	};

	useEffect(() => {
		if (distributionCenterSelected === "default" && (item.isValid || item.budgets?.isValid) && isEditingQuoteItem)
			setChecked(false);
		else
			setChecked(item.isValid && !isEditingQuoteItem && (quoteDetail?.supplierStatus !== "Pendente Money"));
	}, [item, distributionCenterSelected, isEditingQuoteItem]);

	useEffect(() => {
		if (updateChecked) {
			setChecked(false);
			setUpdateChecked(false);
		}
	}, [updateChecked]);

	useEffect(() => {
		const itemHistory = quoteItem?.data?.find(x => x.sequenceNumber === item.sequenceNumber && (x.budgets?.sequence === item.budgets?.sequence || IsNullOrEmpty(item.budgets)));

		setHistoryBudgets(itemHistory?.budgetHistory ?? []);
	}, [item]);

	useEffect(() => {
		item.checked = checked;
		handleChangeSelectItems();
	}, [item, checked]);

	useEffect(() => {
		setEditingQuoteItem(IsNullOrEmpty(item.budgetSaved));
	}, [item.budgetSaved]);

	useEffect(() => {
		notifyHistoryOpened(quoteItemLoading);
	}, [quoteItemLoading]);

	useEffect(() => {
		!suggested && setHistoryBudgets([]);
	}, [suggested]);

	const removeItemSelected = () => {
		let newItens = [...productSelected];
		newItens.splice(newItens.findIndex(x => x.sequenceNumber === item.sequenceNumber), 1);
		setProductSelected(newItens);
	};

	const handleCheckbox = async (e: ChangeEvent<HTMLInputElement>) => {
		setDisableTabs(true);
		setChecked(e.target.checked);

		if (e.target.checked) {
			setProductSelected([...productSelected, { distributionCenter: item.distributionCenter, sequenceNumber: item.sequenceNumber, tabSelected: item.distributionCenter, sequence: item.budgets ? item.budgets?.sequence : 0 }]);
		} else {
			removeItemSelected();
		}

		await _quoteService.changeIsValidBudget(quoteId, item.sequenceNumber, item.budgets?.sequence ?? null);
		item.isValid = checked;
		setDisableTabs(false);
	};

	const suggestedIsCreatedAutomatically = suggested?.isCreatedAutomatically;

	const warningToolTipComponent = useMemo(() => {
		if (warningToolTip) {
			return (
				<Tooltip
					areaRight="10%"
					data-container="body"
					disable
					width={"465px"}
					maxHeight={"222px"}
					border={"1px solid #F9B609"}
					overflow={"auto"}
				>
					<ItemValidityModal
						key={item.sequenceNumber}
						selectedBudgetCd={selectedBudgetCd}
						item={item}
					/>
				</Tooltip>
			);
		}
	}, [warningToolTip]);

	const removeBudgetSaveQuoteItem = () => {
		delete item.budgetSaved;

		item.budgets && delete item.budgets.budgetSaved;
	};

	const addBudgetSaveQuoteItem = (newBudget: NewBudgetProps) => {
		item.isValid = true;
		item.budgetSaved = {
			name: newBudget.name,
			email: newBudget.email,
			date: new Date().toISOString(),
		};
		item.rentabilitySaved = Number(newBudget.rentability);
		item.salePrice = Number(newBudget.salePrice);
		item.conversionAmount = newBudget.conversionAmount;

		if (!item.budgets) {
			item.budgets = {
				sequence: 0,
				distributionCenter: newBudget.distributionCenter,
				salePrice: Number(newBudget.salePrice),
				conversionAmount: newBudget.conversionAmount,
				budgetSaved: item.budgetSaved,
				maps: newBudget.suggested
			};
		} else {
			item.budgets.salePrice = Number(newBudget.salePrice);
			item.budgets.distributionCenter = newBudget.distributionCenter;
			item.budgets.conversionAmount = newBudget.conversionAmount;
			item.budgets.budgetSaved = item.budgetSaved;
			item.budgets.maps = newBudget.suggested;
		};
	};

	const updateConversionAmount = (quantity: number) => {
		item.conversionAmount = quantity;
		if (!item.budgets) {
			item.budgets = {
				conversionAmount: quantity
			};
		} else {
			item.budgets.conversionAmount = quantity;
		};
	};

	const addNewHistory = (newBudget: NewBudgetProps) => {
		const budget = {
			note: newBudget.note || '',
			packagingType: '',
			autoAnswer: false,
			name: newBudget.name,
			email: newBudget.email,
			status: newBudget.status,
			date: new Date().toISOString(),
			quantity: newBudget.conversionAmount,
			salePrice: Number(newBudget.salePrice),
			unitPrice: Number(newBudget.unitPrice),
			totalValue: Number(newBudget.totalValue),
			isValuePricing: newBudget.isValuePricing,
			pitagorasStock: newBudget.pitagorasStock,
			rentability: Number(newBudget.rentability),
			statusDescription: newBudget.statusDescription,
			pitagorasPosition: newBudget.pitagorasPosition,
			distributionCenter: newBudget.distributionCenter,
			supplierProductCode: newBudget.supplierProductCode,
			supplierProductCodeRA: newBudget.supplierProductCodeRA,
			quantityPackaging: newBudget.quotationQuantityPackaging,
			distributionCenterStock: newBudget.distributionCenterStock,
			acceptPriceBelowMin: newBudget.acceptPriceBelowMin || false,
			pitagorasDistributionCenter: newBudget.pitagorasDistributionCenter
		};

		const sequenceMapProduct = newBudget.sequenceBudget ? newBudget.sequenceBudget + 1 : 1;

		if (historyBudgets.length === 0 && detailsItem?.messageAutoAnswer && detailsItem?.messageAutoAnswer?.length > 0 && ((!IsNullOrEmpty(newBudget.sequenceBudget) && newBudget.sequenceBudget === 0) || IsNullOrEmpty(newBudget.sequenceBudget))) {
			setHistoryBudgets([
				{
					...budget,
					minimumPrice: newBudget.itemStock.minimumPriceLock1,
					minimumPriceLock2: newBudget.itemStock.minimumPriceLock2,
					minimumProfitability: newBudget.itemStock.minimumProfitability,
					idealBillingLocation: newBudget.itemStock.idealBillingLocation,
					mapProductSequence: sequenceMapProduct
				},
				{
					...budget,
					autoAnswer: false,
					name: "Resposta Automática",
					date: subSeconds(new Date(), 30).toISOString(),
					note: detailsItem?.messageAutoAnswer?.join("; ") ?? "",
					minimumPrice: newBudget.itemStock.minimumPriceLock1,
					minimumPriceLock2: newBudget.itemStock.minimumPriceLock2,
					distributionCenterStock: newBudget.distributionCenterStock,
					idealBillingLocation: newBudget.itemStock.idealBillingLocation,
					mapProductSequence: sequenceMapProduct
				},
				...historyBudgets
			]);
		} else {
			setHistoryBudgets([
				{
					...budget,
					minimumPrice: newBudget.itemStock.minimumPriceLock1,
					minimumPriceLock2: newBudget.itemStock.minimumPriceLock2,
					idealBillingLocation: newBudget.itemStock.idealBillingLocation,
					minimumProfitability: newBudget.itemStock.minimumProfitability,
					mapProductSequence: sequenceMapProduct
				},
				...historyBudgets
			]);
		}
	};

	const handleExclusion = async (quotationId: string, sequenceNumber: number) => {
		const name = user?.fullName ?? '';
		const email = user?.email ?? '';
		let response;

		if (integrationMessages?.statusViveo === "Pendente Money")
			response = await _quoteService.deleteBudget(quotationId, sequenceNumber, 0, name, email, item?.distributionCenter, item.notes, suggested?.supplierProductcode,);
		else
			response = await _quoteService.deleteSentItem(quotationId, sequenceNumber);

		const newBudget = {
			name,
			email,
			quoteId,
			status: "",
			subUnit: 0,
			unitPrice: "",
			suggested: "",
			salePrice: "",
			historyBudgets,
			totalValue: "",
			rentability: "",
			conversionAmount: 0,
			itemStock: itemStock,
			note: item.note || "",
			isValuePricing: false,
			quotationQuantityPackaging: 0,
			crmCustomerCode: customerCode,
			quotationMultiple: item.multiple,
			outOfStock: itemStock?.stock <= 0,
			sequenceNumber: item?.sequenceNumber,
			factoryPrice: itemStock?.factoryPrice,
			distributionCenter: item?.distributionCenter ?? "",
			supplierProductCode: suggested?.supplierProductcode,
			isPricedAccordingly: itemStock?.isPricedAccordingly,
			acceptPriceBelowMin: item.acceptPriceBelowMin || false,
			supplierProductCodeRA: suggested?.supplierProductCodeRA,
			statusDescription: HistorytSatusDescription.NOT_DELETED
		};

		if (response.status === 200) {
			setDisableTabs(true);
			refreshQuoteSentHeaderTabs && refreshQuoteSentHeaderTabs();
			await _quoteService.resetBuget({ quoteId, sequenceNumber, sequenceBudget: 0 });

			removeItemSelected();
			changeToggle(item.sequenceNumber);

			dispatch({ type: 'CLOSE_TOAST' });
			setDisableTabs(false);
			toastify.success('Item removido com sucesso!');
		} else {
			addNewHistory(newBudget);
			dispatch({ type: 'CLOSE_TOAST' });
			toastify.error('Não foi possível remover item. Por favor, tente novamente.');
		}
	};

	const MemoQuoteItem = useMemo(() => (
		<>
			<QuoteItem
				quoteId={quoteId}
				checked={checked}
				index={index ?? -1}
				cdFilter={cdFilter}
				suggested={suggested}
				setChecked={setChecked}
				customProps={customProps}
				customerCode={customerCode}
				enableButtons={enableButtons}
				addNewHistory={addNewHistory}
				setTotalAmount={setTotalAmount}
				productSelected={productSelected}
				notifyLoading={setQuoteItemLoading}
				setSelectedCDItem={setSelectedCDItem}
				isEditingQuoteItem={isEditingQuoteItem}
				setProductSelected={setProductSelected}
				setSelectedBudgetCd={setSelectedBudgetCd}
				setEditingQuoteItem={setEditingQuoteItem}
				integrationMessages={integrationMessages}
				distributionCenterList={distributionCenters}
				setExclusionCondition={setExclusionCondition}
				addBudgetSaveQuoteItem={addBudgetSaveQuoteItem}
				updateConversionAmount={updateConversionAmount}
				segmentsWithoutPriceLock={segmentsWithoutPriceLock}
				removeBudgetSaveQuoteItem={removeBudgetSaveQuoteItem}
				refreshQuoteSentHeaderTabs={refreshQuoteSentHeaderTabs}
				distributionCenterSelected={distributionCenterSelected}
				item={{
					...suggested,
					maps: mapSavedItem,
					budgets: item.budgets,
					isOriginal: item.isOriginal,
					productCode: item.productCode,
					priorityBCG: item.priorityBCG,
					historyBudgets: historyBudgets,
					unitPurchase: item.unitPurchase,
					hasDuplicate: item.hasDuplicate,
					sequenceNumber: item.sequenceNumber,
					rentabilitySaved: item.rentabilitySaved,
					notes: item.budgets?.notes ?? item.notes,
					productsSuggestion: item.productsSuggestion,
					hospitalProductDescription: item.productName,
					messageAutoAnswer: detailsItem?.messageAutoAnswer,
					salePrice: item.budgets?.salePrice ?? item.salePrice,
					budgetSaved: item.budgets?.budgetSaved ?? item.budgetSaved,
					distributionCenterDuplicated: item.distributionCenterDuplicated,
					distributionCenterDefault: item?.distributionCenterDefault,
					packagingType: item.budgets?.packagingType ?? item.packagingType,
					distributionCenter: item.budgets?.distributionCenter ?? item.distributionCenter,
					conversionAmount: item.budgets?.conversionAmount && item.budgets?.sequence ? item.budgets?.conversionAmount : item.conversionAmount,
					skuPriorityItem: item.skuPriorityItem
				}}
			/>
			<div className="warningToolTip">
				{warningToolTipComponent}
			</div>
		</>
	), [suggested, quoteId, item, warningToolTip, distributionCenters, productSelected, quoteDetail, historyBudgets]);

	const ButtonsActionItens = useMemo(() => {
		return (
			<Visibility visible={enableButtons || distributionCenterSelected === 'default' || (!sentQuoteStatus && !itemStock?.blocked)}>
				<ActionIcons
					distributionCenterSelected={distributionCenterSelected}
					notifyTooltipToClose={notifyTooltipToClose}
					setwarningToolTip={setwarningToolTip}
					notifyLoading={setQuoteItemLoading}
					selectedCDItem={selectedCDItem}
					warningToolTip={warningToolTip}
					customerCode={customerCode}
					isOrder={isOrder}
					quoteId={quoteId}
					item={{
						...suggested,
						hospitalProductCode: item.productCode,
						buyerIdentifier: item.buyerIdentifier,
						sequenceNumber: item.sequenceNumber,
						distributionCenter: item.distributionCenter,
						packagingType: item.packagingType,
						notes: item.notes,
						productsSuggestion: item.productsSuggestion,
						priorityBCG: item.priorityBCG
					}}
					suggested={suggested}
				/>
			</Visibility>
		);
	}, [suggested, quoteId, item, warningToolTip, selectedCDItem]);

	const visibleQuoteItem = suggested?.id && !IsNullOrEmpty(itemStock);

	const visibleHistoryEdit = suggested && historyBudgets.length > 0;

	const mapItem: ProductsSuggestionProps = useMemo(() => {
		if (IsNullOrEmpty(item.budgetSaved) || !mapSavedItem)
			return suggested;

		return mapSavedItem;
	}, [item.budgetSaved, item, mapSavedItem]);

	const itemOriginalSent = !item.hasDuplicate && item.isOriginal;
	const hideDeleteButton = useMemo(() => {
		if (quoteItem)
			return quoteItem?.data?.filter(x => x.sequenceNumber === item.sequenceNumber && !x.budgets?.deleted).length;
	}, [quoteItem, item]);
	const newBudgetVisible = bionexoStatus === StatusType.OPEN && viveoStatus === SupplierStatusType.VALIDATE_PORTAL;
	const conditionVisibleButtonsDuplicate = (!newBudgetVisible && tabSelected && (!isEditingQuoteItem || item.budgets?.sequence === 1)) && !isQuoteExpired;

	useEffect(() => { updateConversionFactorState(); }, [quoteItem]);

  const hasPriorityDisplayed = item.hasBCG && item.priorityBCG && item.priorityBCG?.displayed;
  const hasNoBCGAndPriority = !item.hasBCG && !item.priorityBCG;

  const notBlockBCG = bcgOnly
    ? hasPriorityDisplayed || hasNoBCGAndPriority
    : !user?.isBCGUser || hasPriorityDisplayed || hasNoBCGAndPriority;

	const textTooltip = (text: string) => notBlockBCG ? text : "Esse item foi desconsiderado por condições comerciais";

	const approvedOrReprovedMapAutomatic = async (suggestedId: string, isApproved: boolean) => {
		if (isApproved && approveMapProduct) {
			const data: UpdateApprovedMapAutomaticProps = {
			isApproved,
			supplierProductCode: suggested.supplierProductcode,
			hospitalProductCode: item.productCode ?? item.code ?? "",
			hospitalDocumentNumber: item.buyerIdentifier ?? ""
			};
			approveMapProduct(suggestedId, item.sequenceNumber, data);
		} else if (reproveMapProduct) {
			 reproveMapProduct({
				...item,
				...suggested
			});
		  }
		};

	const renderButtonsApprovedMaps = () => (
		<S.Cell className="actionsIcons" isAutomatic={suggestedIsCreatedAutomatically}>
			<Button tooltip="Aprovar Item" className="IconsDownloadSheetButton pl-0" onClick={() => approvedOrReprovedMapAutomatic(suggested.id, true)}>
			<img src={confirmBtn} />
			</Button>
			<Button tooltip="Reprovar Item" className="IconsDownloadSheetButton" onClick={() => approvedOrReprovedMapAutomatic(suggested.id, false)}>
			<img src={removeBtn} />
			</Button>
		</S.Cell>
	);

	const renderButtonsActions = () => (
		<>
			<div className="actionIcons">
				<Visibility visible={isEditingQuoteItem && (!sentQuoteStatus || unblockedStockAndNotDefaultDc)}>
					{ButtonsActionItens}
				</Visibility>
			</div>
			<div className="actionBtn">
				<Visibility visible={editVisibility}>
					<QuoteActionButton
						item={suggested}
						quoteId={quoteId}
						id={suggested?.id}
						isCustomer={false}
						quoteCode={item.quoteCode}
						isValid={isEditingQuoteItem}
						isQuoteExpired={isQuoteExpired}
						onClick={customProps?.showModal}
						sequenceNumber={item.sequenceNumber}
						sequence={item.budgets?.sequence ?? 0}
						tooltip="Não é possível criar DE/PARA para um item fora de portfólio"
						productPortfolio={isNoSegmented === false || IsNullOrEmpty(isNoSegmented) ? !item.outPortfolio : portfolio}
					/>
				</Visibility>
			</div>
		</>
	)

	return (
		<>
			<S.TDRow className="isCustomer" displayItem={notBlockBCG}>
				<S.Cell className="isCustomer">
					<CheckboxInput
						name={item.sequenceNumber}
						value={item.sequenceNumber}
						checked={checked ? suggested : false}
						disabled={disableCheckboxInput || !enableButtons || ExistsDuplicatedItem(item, quoteItem) || !notBlockBCG}
						onChange={(e: ChangeEvent<HTMLInputElement>) => !disableTabs && handleCheckbox(e)}
					/>
				</S.Cell>
				<S.Cell className="sequenceNumber">
					<S.Cell className="statusIcon">
						<StatusCircleOptions color={colors.cyanLightViveo} />
					</S.Cell>
					<p>{item.sequenceNumber}</p>
				</S.Cell>
				<S.Cell className="id">
					<p>{item.productCode}</p>
				</S.Cell>
				<S.Cell className="description">
					<Text showTip toolTipPlace="left" showTipContent={textTooltip(item?.productName)}>
						{item?.productName}
					</Text>
				</S.Cell>
				<S.Cell className="tagsMedicineTipe"></S.Cell>
				<S.Cell className="producer">
					<Text showTip toolTipPlace="left" showTipContent={textTooltip(item.preferedBrands)}>
						{item.preferedBrands}
					</Text>
				</S.Cell>
				<S.Cell className="quantity">
					<p>{item.quantity}</p>
				</S.Cell>
				<S.Cell className="unit">
					<Text showTip toolTipPlace="left" showTipContent={textTooltip(item.unitPurchase)}>
						{item.unitPurchase}
					</Text>
				</S.Cell>
				<S.Cell className="conversionFactor">
					<p></p>
				</S.Cell>
				<S.Cell className="portifolioContainer">
					<Visibility visible={!!!suggested && item?.isOriginal && !item?.budgets?.sent && notBlockBCG}>
						<Toggle
							isLine={true}
							disabled={disabled}
							label={'Portfólio'}
							id={`${item.productCode}tooglePortifolio`}
							onChange={() => handleOutPortfolio()}
							toggled={isNoSegmented === false || IsNullOrEmpty(isNoSegmented) ? !item.outPortfolio : portfolio}
						/>
					</Visibility>
				</S.Cell>
			</S.TDRow>
			{/* Linha do mapeamento */}
			<S.TDRow className={`${visibleQuoteItem ? '' : 'hide-border-quote-item'}`} displayItem={notBlockBCG}>
				<S.Cell className="isCustomer"></S.Cell>
				<S.Cell className="sequenceNumber">
					<S.Cell className="statusIcon">
						<StatusCircleOptions color={colors.greenDarkViveo} />
					</S.Cell>
					<p>{item.sequenceNumber}</p>
				</S.Cell>

				<MapProductLine
					suggested={mapItem}
					notBlockBCG={notBlockBCG}
					textTooltip={textTooltip}
					quantityRule={quantityRule}
					isEditing={isEditingQuoteItem}
					sequenceNumber={item.sequenceNumber}
				/>

				<S.Cell className="actions">
					<Visibility visible={notBlockBCG}>
						<Visibility visible={useMoney || !suggested}>
							<div>
								<S.ExclusionToolTip disabled={exclusionCondition}>
									<Visibility visible={distributionCenterSelected !== 'default' && ((exclusionVisibility && itemOriginalSent && hideDeleteButton === 1) || (sentQuoteStatus && itemStock?.blocked))}>
										<Button disabled={exclusionCondition} onClick={() => toastExclusion(handleExclusion, quoteId, item.sequenceNumber)}>
											<img src={deleteBtn} />
										</Button>
									</Visibility>
								</S.ExclusionToolTip>
							</div>
						<VisibilityConditional
							condition={suggestedIsCreatedAutomatically && !suggested?.isApproved}
							firstOption={() => renderButtonsApprovedMaps()}
							secondOption={() => renderButtonsActions()}
						/>
						</Visibility>

						<Visibility visible={suggested && !useMoney}>
							<Loading onlySpinner size={14} />
						</Visibility>

						<Visibility visible={quoteItem?.error ?? false}>
							<IndicatorRefreshButton
								html={true}
								icon={refreshRed}
								refreshSize='14px'
								onReload={() => setRenderAgainMoney(true)}
								tooltip={`<p class='text-styles text-center'>Falha ao carregar dados do Money.<br />Clique para tentar novamente.</p>`}
							/>
						</Visibility>
					</Visibility>
				</S.Cell>
			</S.TDRow>

			<Visibility visible={notBlockBCG}>
				<Visibility visible={visibleQuoteItem}>
					<S.TDRow displayItem={notBlockBCG}>
						<S.Cell className="quoteItem">
							{MemoQuoteItem}
						</S.Cell>
					</S.TDRow>
				</Visibility>

        <S.FooterIndicatorsContainer>
          <Visibility visible={conditionVisibleButtonsDuplicate}>
            <S.Cell className="">
              <NewBudgetButtons
                item={item}
                quoteId={quoteId}
                productSelected={productSelected}
                setProductSelected={setProductSelected}
                removeBudgetSaveQuoteItem={removeBudgetSaveQuoteItem}
                distributionCentersLength={distributionCenters.length}
                distributionCenterSelected={distributionCenterSelected}
                refreshQuoteSentHeaderTabs={refreshQuoteSentHeaderTabs}
              />
            </S.Cell>
          </Visibility>
          <Visibility visible={item?.skuPriorityItem}>
            <IndicatorItem
              priorityItem={item?.skuPriorityItem}
              iconIndicator={priorityIcon}
              titleIndicator="SKU Prioritário"
              hasButton={conditionVisibleButtonsDuplicate}
            />
          </Visibility>
        </S.FooterIndicatorsContainer>

				<Visibility visible={itemStock?.blocked && sentQuoteStatus && distributionCenterSelected !== 'default'}>
					<S.Cell className="blockMessage">
						<Text color="#E02828" size={12}><strong>Trava comercial</strong> {itemStock?.blockMessage}</Text>
					</S.Cell>
				</Visibility>

				<Visibility visible={visibleHistoryEdit && useMoney}>
					<BudgetHistory suggested={suggested} orderBudgetHistory={orderBudgetHistory} history={historyBudgets} />
				</Visibility>
				<Visibility visible={item?.hasDuplicate ?? false}>
					<AnotherCd>
						<VisibilityConditional
							condition={item?.isOriginal}
							firstOption={() => duplicateItem(item?.distributionCenterDuplicated, true)}
							secondOption={() => duplicateItem(item?.distributionCenterDuplicated, false)}
						/>
					</AnotherCd>
				</Visibility>
			</Visibility>
		</>
	);
};

export default TRow;
